import { create } from 'zustand';

export type Toast = {
  id: string;
  message: string;
};

const TOAST_DURATION_MS = 5000;

interface ToastStore {
  toasts: Toast[];
  addToast: (toast: Toast) => void;
  removeToast: (id: string) => void;
}

export const useToastStore = create<ToastStore>()((set, get) => ({
  toasts: [],
  addToast: (toast) => {
    set((state) => ({ toasts: [...state.toasts, toast] }));
    setTimeout(() => get().removeToast(toast.id), TOAST_DURATION_MS);
  },
  removeToast: (id) =>
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}));
